import { Pipe, PipeTransform } from '@angular/core';
import { CoreService } from './service/core.service';

@Pipe({
  name: 'arabicDigits'
})
export class ArabicDigitsPipe implements PipeTransform {

  transform(value: any): string {
    if (value === null || value === undefined) return '';
    const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return value.toString().replace(/\d/g, d => arabicDigits[+d]);
  }

}
